import { ISelectOption } from '../../../UIPackage/MainModule/components/SelectInput';
import { IPassportMassDeleteReason } from '../../../APIPackage/CatalogsModule/interfaces/IPassportMassDeleteReason';

export function createPassportMassDeleteReasonSelectOption(reason: IPassportMassDeleteReason): ISelectOption {
  return {
    ...reason,
    label: reason.name,
  };
}
